import { actionTypes } from '../../../types';

export const saveInfluencerProfileRequest = (payload, callback) => ({
    type: actionTypes.SAVE_INFLUENCER_PROFILE_REQUEST,
    payload,
    callback,
});

export const saveInfluencerProfileSuccess = (payload) => ({
    type: actionTypes.SAVE_INFLUENCER_PROFILE_SUCCESS,
    payload,
});

export const saveInfluencerProfileFailure = (payload) => ({
    type: actionTypes.SAVE_INFLUENCER_PROFILE_FAILURE,
    payload,
});

export const saveInfluencerProfileReset = () => ({
    type: actionTypes.SAVE_INFLUENCER_PROFILE_RESET,
});

export const saveInfluencerProfileResetAll = () => ({
    type: actionTypes.SAVE_INFLUENCER_PROFILE_RESET_ALL,
});
